<template>
	<div class="c-generations">
		<PageHeader title="AI Generations" :showMenu="true">
			<template v-slot:title> Your saved AI generations </template>
			<template v-slot:footer>
				<router-link to="/script" class="btn btn-primary btn-box">
					<svg
						width="24"
						height="24"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M16 11.9999L8 12.0001M12 16V8.00012M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
							stroke="currentColor"
							stroke-width="2"
							stroke-linecap="round"
							stroke-linejoin="round"
						/>
					</svg>
					<span> Create script </span>
				</router-link>
			</template>
		</PageHeader>
		<div class="c-generations__inner">
			<List></List>
		</div>
	</div>
</template>

<script>
import PageHeader from '@swipekit/components/utils/page-header';
import List from './list';

export default {
	components: {
		PageHeader,
		List,
	},

	data: function () {
		return {};
	},

	methods: {},
};
</script>

<style lang="scss">
.c-generations {
	&__inner {
		position: relative;
		z-index: 1;

		> header {
			display: flex;
			justify-content: center;
			align-items: center;
			padding: 1rem var(--spacer-sm);
		}
	}
}
</style>
